function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length,c.length);
        }
    }
    return false;
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}

$(document).ready(function(){
    if(!getCookie('roasurl')){
        /*Create a variable with the url*/
        var urlVariables = location.search.substring(1);
        
        /*Valid that the url contains "utm"*/
        if(urlVariables.includes('utm')){
            setCookie('roasurl', window.location.href, 30); /*save cookie for 30 days*/
        /*If the url does not contain utm sabe the referrer*/
        } else if (document.referrer){
            setCookie('roasurl', document.referrer, 30);
        /*If the url does not contain utm and the referrer is false save the first url*/
        } else {
            setCookie('roasurl', window.location.href, 30);
        }
    }
});


// WEBPACK FOOTER //
// ./js/partials/roas.js